module.exports = __webpack_public_path__ + "img/mag-glass-key.3c2c81d3.svg";